import { createContext } from 'react';
import { MessageReceiverMap } from '../interfaces';

interface MessageSettingContextProps {
    receiverMap: MessageReceiverMap;
    onReceiverMapChange: (receiverMap: MessageReceiverMap) => void;
    smsPackCount: number;
}

const MessageSettingContext = createContext<MessageSettingContextProps>({
    receiverMap: {},
    onReceiverMapChange: () => {},
    smsPackCount: 0
});

MessageSettingContext.displayName = 'MessageSettingContext';
export default MessageSettingContext;
